<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>MOTIVOS RECHAZO PTI</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>CT_Rechazo PTI Px</div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-row align-v="center" align-h="end">
            <b-col>
              <b-form-group align="left">
                <label for="nombreBusq">Palabra clave</label>
                <b-input-group size="sm" class="mb-2" id="nombreBusq" lab>
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input
                    name="nombre"
                    placeholder="Nombre del motivo"
                    v-model="filtro.palabraClave" @keydown.enter.native="obtenerMotivosRechazoLista"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col></b-col>

            <b-col
              align="right"
              v-if="$localStorageService.can('CT_01_PTI_Rech_Px_crear')"
            >
              <b-button
                v-b-tooltip.hover
                title="Crear menú"
                variant="outline-success"
                @click="agregar()"
                >Crear motivo
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-table
            id="Pendientes"
            thead-tr-class="columnas"
            :items="datosTabla"
            :fields="fields"
            :per-page="registrosPorPagina"
            :current-page="paginaActual"
            responsive="true"
            class="parrafos"
            fixed
          >
            <template v-slot:cell(Acciones)="row">
              <b-button-group>
                <b-button
                    v-if="$localStorageService.can('CT_01_PTI_Rech_Px_edit')"
                    title="Modificar motivo"
                    size="sm"
                    variant="outline-warning"
                     @click="modificar(row.item)"
                ><em class="fa fa-pencil"></em></b-button>
                <b-button v-if="!row.item.registro && $localStorageService.can('CT_01_PTI_Rech_Px_act')"
                          title="Activar motivo"
                          variant="outline-danger"
                          size="sm"
                         @click="activarDesactivarMotivo(row.item)"
                ><em class="fa fa-undo"></em></b-button>
                <b-button v-else-if="$localStorageService.can('CT_01_PTI_Rech_Px_act')"
                          title="Eliminar motivo"
                          variant="outline-danger"
                          size="sm"
                          @click="activarDesactivarMotivo(row.item)"
                >
                  <b-icon icon="trash-fill"></b-icon>
                </b-button>
              </b-button-group>

            </template>
          </b-table>
       <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="registrosPorPagina"
                aria-controls="my-table1"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>
    </b-container>
        <b-modal
        v-model="show"
        :title="tituloModal"
        size="lg"
    >
     <b-container fluid>
          <b-row>
               <b-col>
                   <b-form>
                       <b-form-group align="left">
                <label for="descripcion">Nombre Motivo
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input id="descripcion" name="descripcion" placeholder="Nombre del motivo"
                               v-model="$v.motivo.descripcion.$model"
                                :state="validateState('descripcion')"                            
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
                   </b-form>
               </b-col>
          </b-row>
     </b-container>
         <div slot="modal-footer">
        <b-button variant="outline-primary" :disabled="loaderAcciones" @click="guardar()">
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
                        <b-spinner small></b-spinner>
                    Cargando...
                    </span>
        </b-button>
        <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cancelar</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Header from "../../components/Header";
import {required} from "vuelidate/lib/validators";
export default {
  name: "motivoRechazoPti",
  components: {
    Header,
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      datosTabla: [],
      fields: [
        { key: "idMotivoRechazoPti", label: "ID", sortable: true },
        { key: "descripcion", label: "Nombre", sortable: true },
        "Acciones",
      ],
      registrosPorPagina: 10,
      paginaActual: 0,
      filtro: {
        id: null,
        palabraClave: null,
        registroActivo: null
      },
     tituloModal: '',
     loaderAcciones: false,
     show: false,
     motivo:{
        idMotivoRechazoPti: null,
        descripcion: null,
        registro: null,
        estatusM2DTO: null
      },
      loader: false,
    };
  },
  validations: {
    motivo: {
      descripcion:{required}
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
     this.obtenerMotivosRechazoLista();
  },
  methods: {
    obtenerMotivosRechazoLista() {
  this.loader = true;
      this.$http
        .post(this.$api + "catalogos/obtenerRechazoPtiFiltro", this.filtro)
        .then((respuesta) => {
          if (respuesta.data.data) {
            this.datosTabla = respuesta.data.data;
          }
        })
        .finally(() => {
        this.loader = false;
        });
    },
    activarDesactivarMotivo(item){
     const mensaje = item.registro ? '¿Está seguro de desactivar el motivo?' : '¿Está seguro de activar el motivo?';
      this.$swal({
        icon: "warning",
        text: mensaje,
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          const parametros = {
            idMotivoRechazoPti: item.idMotivoRechazoPti,
          }
          this.$http.post(this.$api + 'catalogos/desctivarActivarMotivo', parametros).then(respuesta => {
                if (respuesta.data.data) {
                  item.registro = !item.registro;
                  this.$swal.fire({
                    icon: "info",
                    title: "Aviso",
                    text: "El motivo se actualizó correctamente",
                  });
                }
              }
          )
        }
      })
    },
    agregar() {
      this.motivo = {
        idMotivoRechazoPti: null,
        descripcion: null,
        registro: null,
      };
      this.tituloModal = 'Agregar motivo';
      this.show = true;
    },
    cerrarModal() {
      this.showDetalle = false;
      this.show = false;
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.motivo[name];
      return $dirty ? !$error : null;
    },
    guardar(){
            this.$v.motivo.$touch();
      if (this.$v.motivo.$anyError) {
        return;
      }
      if (!this.$v.motivo.$invalid) {
        this.loaderAcciones = true;
        this.$http.post(this.$api + 'catalogos/guardarMotivoRechazo', this.motivo).then(respuesta => {
              if (respuesta.data.data) {
                this.filtro = {
                   id: null,
                   palabraClave: null,
                  registroActivo: null
                };
                this.obtenerMotivosRechazoLista();
                this.show = false;
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "El menú se guardó correctamente",
                });
              }
            }
        ).finally(() => {
              this.loaderAcciones = false;
            }
        )
      }
    },
    modificar(item) {
      this.motivo = item;
      this.tituloModal = 'Modificar motivo';
      this.show = true;
    },
  },
};
</script>

<style>
</style>